<template>
    <div class="login-wrap" v-loading="isShowloading">
        <pointwave :color="0x097bdb" />
        <div class="ms-login">
            <div class="ms-title">后台管理系统</div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="ms-content">
                <el-form-item prop="username">
                    <el-input v-model="ruleForm.account" placeholder="username">
                        <el-button slot="prepend" icon="el-icon-lx-people"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input type="password" placeholder="password" v-model="ruleForm.password" @keyup.enter.native="submitForm()">
                        <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
                    </el-input>
                </el-form-item>
                <div class="login-btn">
                    <el-button type="primary" @click="submitForm()" @keydown.enter.native="submitForm()">登录</el-button>
                </div>
                <p class="login-tips"></p>
            </el-form>
        </div>
    </div>
</template>

<script>
    import Pointwave from '@/components/Pointwave.vue'
    import api from "@/api/api";
    export default {
        name: 'Login',
        components: {
            Pointwave
        },
        data: function(){
            return {
                ruleForm: {
                    account: '',
                    password: ''
                },
                isShowloading: false,
                rules: {
                    account: [
                        { required: true, message: '请输入用户名', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' }
                    ]
                }
            }
        },
        methods: {
            submitForm() {
                if (!this.ruleForm.account){this.$message.error('用户账户不能为空!');return false}
                if (!this.ruleForm.password){this.$message.error('用户密码不能为空!');return false}
                this.isShowloading = true;
                api.getLogin(this.ruleForm).then((res) => {
                    if (res) {
                        if (res.data.code) {
                            this.$message.error(res.data.msg);
                        }else {
                            this.$store.commit('setToken', res.data.data.userInfo.token);
                            this.$store.commit('setUsername', res.data.data.userInfo.name);
                            this.$store.commit('setUserid', res.data.data.userInfo.userid);
                            this.$router.push('/');
                        }
                    } else {
                        this.$message.error('链接服务器失败!');
                        return false;
                    }
                    this.isShowloading = false;
                })
            }
        },
        created() {
            let self = this;
            document.onkeydown = function(e) {
                let key = window.event.keyCode;
                if (key === 13) {
                    self.submitForm();
                }
            }
        },
        beforeDestroy() {
            document.onkeydown = function (e) {
                let key = window.event.keyCode;
                if (key === 13) {
                }
            }
        }
    }
</script>

<style scoped>
    .login-wrap{
        position: relative;
        width:100%;
        height:100%;
        background-color: #15255B;
    }
    .ms-title{
        width:100%;
        line-height: 50px;
        text-align: center;
        font-size:20px;
        color: #000;
        border-bottom: 1px solid #ddd;
    }
    .ms-login{
        position: absolute;
        left:50%;
        top:50%;
        width:350px;
        margin:-190px 0 0 -175px;
        border-radius: 5px;
        background: rgba(255,255,255, 1);
        overflow: hidden;
    }
    .ms-content{
        padding: 30px 30px;
    }
    .login-btn{
        text-align: center;
    }
    .login-btn button{
        width:100%;
        height:36px;
        margin-bottom: 10px;
    }
    .login-tips{
        font-size:12px;
        line-heigh:#000;
    }
</style>
